import { action, computed, flow, observable, makeObservable } from "mobx"
import { appFeatures } from "AppFeatures"
import { appStats } from "utils/TestSupport"
import { serviceUrls } from "store/qlapi/ServiceUrls"
import { rootStore } from "store/RootStore"
import { moment } from "store/util/moment"

import { getCoCoModule } from "store/page/repo/CoCoModule"
const CoCo = await getCoCoModule()

export class CoCoDiscover {
   refreshCount = 0
   heroes = []
   categories = []
   lanes = []
   lanesCount = 0
   continueWatching = []
   //bmEvents = []

   constructor() {
      makeObservable(this, {
         refreshCount: observable,
         heroes: observable.shallow,
         categories: observable,
         lanes: observable.shallow,
         lanesCount: observable,
         continueWatching: observable.shallow,
         init: action,
         discover: action,
         //bmEvents: observable
      })
   }

   init = flow(function* () {
      this.refreshCount = 0
      this.heroes = []
      this.categories = []
      this.lanes = []
      this.lanesCount = 0
      this.continueWatching = []
      //this.bmEvents = []
      yield this.version()
      yield this.discover(true)
   })

   _heroToCamelCase(cocoHero) {
      const mapping = {
         channel_id: "channelId", display_text: "displayText", event_id: "eventId", id: "id",
         picture_uri: "pictureUri", series_id: "seriesId", title: "title"
      }
      const result = {}
      Object.getOwnPropertyNames(Object.getPrototypeOf(cocoHero)).map((key) => {
         //console.debug("key %o, mapping %o, value %o ", key, mapping[key], cocoHero[key], typeof mapping[key] === "function", typeof mapping[key] === "undefined")
         if (typeof mapping[key] !== "function" && typeof mapping[key] !== "undefined") result[mapping[key]] = cocoHero[key]
         //console.debug("=", result)
      })
      /*
      const res = Object.fromEntries(Object.entries(cocoHero).map((key, value) => {
         console.debug("->", Object.getPrototypeOf(cocoHero), Object.getOwnPropertyNames(Object.getPrototypeOf(cocoHero)), Object.fromEntries(Object.entries(cocoHero)), cocoHero, key, value, Object.fromEntries(Object.entries(cocoHero)))
         console.debug("key value", key, value)
         return [mapping[key], value]
      }))
      */
      return result
   }

   /*
   _laneToCamelCase(cocoLane) {
      const mappingLane = { id: "id", title: "title" }
      const mappingItem = { series_episode: "seriesEpisode", series_folder: "seriesFolder" }
      const mappingProgram = { channel_id: "channelId", }

      const result = {}
      Object.getOwnPropertyNames(Object.getPrototypeOf(cocoLane)).map((key) => {
         //console.debug("key %o, mapping %o, value %o ", key, mapping[key], cocoLane[key], typeof mapping[key] === "function", typeof mapping[key] === "undefined")
         if (typeof mappingLane[key] !== "function" && typeof mappingLane[key] !== "undefined") result[mappingLane[key]] = cocoLane[key]
      })
      result.items = cocoLane.items
      console.debug("lane=", result)

      return {}
   }
   */

   _discoverToCamelCase(cocoObj) {
      const heroes = cocoObj.heroes
      for (let i = 0; i < heroes.length; i++) {
         const result = this._heroToCamelCase(heroes[i])
         heroes[i] = result
         //console.debug("hero", result, heroes[i], heroes)
      }
      this.heroes = heroes

      const lanes = cocoObj.lanes
      /*
      for (let i = 0; i < lanes.length; i++) {
         const result = this._laneToCamelCase(lanes[i])
         lanes[i] = result
         //console.debug("lane", result, lanes[i], lanes)
      }
      */
      this.lanes = lanes
      //console.debug("_discoverToCamelCase heroes %o, lanes %o", heroes, lanes)
   }

   version = flow(function* () {
      try {
         console.debug("CoCo %s", CoCo.version())
         let result = yield CoCo.apiFetchReplayGuideVersionRaw()
         // CoCo returns string instead of object, need to convert to object
         console.debug("replayGuide version result", result, typeof result === "string")
         if (typeof result === "string") result = JSON.parse(result)
         const rgVersion = `${result["build_tag"]} (${result["build_date"]})`
         appStats.replayGuide = rgVersion
         return rgVersion
      }
      catch (err) {
         console.error("Discover.version", err)
         appStats.replayGuide = err + ` (${serviceUrls.replayguide})`
         return "undefined"
      }
   })

   discover = flow(function* (reload) {
      // MTVW-980: CoCo 0.7.300 to 0.8.1 use always cache
      //reload = false
      const requestId = {id: this.refreshCount, reload: reload}
      console.debug("discover loadReq initial %o", requestId)

      try {
         let result = yield CoCo.fetchDiscover(reload ? CoCo.FetchStrategy.NetworkFirst : CoCo.FetchStrategy.CacheFirst)
			//this._discoverToCamelCase(result)
         this.heroes = result.heroes
         //this.heroes = [result.heroes[0]]
         this.categories = result.categories
         //console.debug("categories", this.categories)
         this.lanes = result.lanes
         //console.debug("fetchDiscover", result)
      }
      catch (err) {
         console.error("fetchDiscover", err)
      }
      try {
         // CoCo v0.4.1500 disabled continue_watching lane, v0.4.1700 reenabled them
         if (appFeatures.bookmarksEnabled) {
            if (this.lanes?.[0]?.id === "continue_watching") {
               console.debug("GOT continue_watching lane")
               //this.continueWatching = this._extendWatchingItems(this.lanes[0].items)
               this.continueWatching = this.lanes[0].items
            }
            // alternative method
            //else yield this.getContinueWatching()
         }
         // remove continue_watching if bookmarks are not enabled
         else if (this.lanes?.[0]?.id === "continue_watching") this.lanes.splice(0, 1)
         this.lanesCount = this.lanes?.length ?? 0
      }
      catch (err) {
         console.error("getContinueWatching", err)
      }

      this.refreshCount++
      console.debug("discover loadReq %o, refreshCount %o", requestId, this.refreshCount)
      //console.debug("discover refreshCount %s, lanes %o, heroes %o, continue watching %o, this.refreshCount, this.lanes, this.heroes, this.continueWatching)
      for (let i = 0; i < this.lanes.length; i++) {
         //console.debug("discover items", this.lanes?.[i].items?.length, this.lanes?.[i]?.title)
			// MTVW-1094: filter new_recordings
			if (this.lanes?.[i]?.id === "new_recordings") {
				//console.debug("discover filtering", this.lanes[i].id, this.lanes[i].items)
				//console.debug("discover lanes", this.lanes[i])
				const filtered = this.lanes[i]?.items?.filter(i => {
					//console.debug("dicover item", i?.program?.title, i?.program?.channelId, i)
					const channelId = i?.program?.channelId ?? i?.seriesEpisode?.channelId ?? i?.seriesFolder?.channelId
					return !rootStore.channelsService?.isAdultChannel(channelId)
				})
				console.debug("discover %s, unfiltered %s, filtered %s", this.lanes[i].id, this.lanes[i].items.length, filtered.length)
				this.lanes[i].items = filtered
			}
		}
   })

   _extendNewRecordingItem(item) {
      if ('Title' in item) return
      //console.debug("item", item, item?.Titles?.Title?.[0])
      try {
         Object.defineProperty(item, 'Title', {
            get() {
               return this.Titles?.Title?.[0]
            }
         })
         Object.defineProperty(item, 'Content', {
            get() {
               return this.Contents?.Content?.[0]
            }
         })
         Object.defineProperty(item, 'PosterUrl', {
            get() {
               return this.Title?.Pictures.Picture?.[0].Value
            }
         })
         Object.defineProperty(item, 'LogoUrl', {
            get() {
               return rootStore.channelsService?.getChannel(this.Channels?.Channel?.[0].id).logoUrl
            }
         })
         // DO NOT use 'AvailabilityDurationInMinutes' if extending the prototype, it's already applied in _extendWatchingItem
         /*
         if ('AvailabilityDurationInMinutes' in item) {
            console.debug("AvailabilityDurationInMinutes", item)
            delete item.AvailabilityDurationInMinutes
         }
         */
         Object.defineProperty(item, 'DurationInMinutes', {
            get() {
               return Math.round(this.DurationInSeconds / 60)
            }
         })
         item.AvailabilityStartDateFormat = function (format) {
            return moment(this.StartTime).format(format)
         }
         // DO NOT use 'eventType' if extending the prototype, it's already applied in _extendWatchingItem
         Object.defineProperty(item, 'evType', {
            get() {
               const timeCurr = moment().utc().valueOf()
               return moment(this.StartTime).valueOf() <= timeCurr && moment(this.EndTime).valueOf() > timeCurr ? "c" : moment(this.StartTime).valueOf() >= timeCurr ? "n" : "p"
            }
         })
      }
      catch (err) {
         console.error("_extendNewRecordingItem", err)
      }
   }

   _extendWatchingItem(item) {
      if ('logoUrl' in item) return
      try {
         Object.defineProperty(item, 'logoUrl', {
            get() {
               return rootStore.channelsService?.getChannel(this.channelId).logoUrl
            }
         })
         Object.defineProperty(item, 'AvailabilityDurationInMinutes', {
            //configurable: true,
            get() {
               return Math.round(moment.duration(this.duration).asMinutes())
            }
         })
         item.AvailabilityStartDateFormat = function (format) {
            return moment(this.startMillis).format(format)
         }
         Object.defineProperty(item, 'eventType', {
            get() {
               const timeCurr = moment().utc().valueOf()
               return this.startMillis <= timeCurr && this.endMillis > timeCurr ? "c" : this.startMillis >= timeCurr ? "n" : "p"
            }
         })
      }
      catch (err) {
         console.error("_extendWatchingItem", err)
      }
   }

   _extendWatchingItems(items) {
      const filtered = []
      for (let i = 0; i < items.length; i++) {
         const item = items[i]
         if (item.position >= item.endMillis) {
            console.warn("bookmark past end! start %o, end %o, position %o", moment(item.startMillis).utc().format("DD.MM HH:mm:ss"), moment(item.endMillis).utc().format("DD.MM HH:mm:ss"), moment(item.position).utc().format("DD.MM HH:mm:ss"))
            items[i].position = item.endMillis - 60000
         }
         if (item.position <= item.startMillis) {
            console.warn("bookmark before start! start %o, end %o, position %o", moment(item.startMillis).utc().format("DD.MM HH:mm:ss"), moment(item.endMillis).utc().format("DD.MM HH:mm:ss"), moment(item.position).utc().format("DD.MM HH:mm:ss"))
            items[i].position = item.startMillis + 60000
         }
         if (!items[i].isAdult) {
            this._extendWatchingItem(item)
            filtered.push(item)
         }
      }
      return filtered
   }

   getContinueWatching = flow(function* () {
      let result = yield CoCo.fetchContinueWatchingLane()
      // CoCo returns string instead of object, need to convert to object
      if (typeof result === "string") result = JSON.parse(result)
      /* RECHECK
      const proto = Object.getPrototypeOf(result.items[0])
      this._extendWatchingItem(proto)
      */
      const filtered = []
      for (let i = 0; i < result.items.length; i++) {
         const item = result.items[i]
         if (item.position >= item.endMillis) {
            console.warn("bookmark past end! start %o, end %o, position %o", moment(item.startMillis).utc().format("DD.MM HH:mm:ss"), moment(item.endMillis).utc().format("DD.MM HH:mm:ss"), moment(item.position).utc().format("DD.MM HH:mm:ss"))
            result.items[i].position = item.endMillis - 60000
         }
         if (item.position <= item.startMillis) {
            console.warn("bookmark before start! start %o, end %o, position %o", moment(item.startMillis).utc().format("DD.MM HH:mm:ss"), moment(item.endMillis).utc().format("DD.MM HH:mm:ss"), moment(item.position).utc().format("DD.MM HH:mm:ss"))
            result.items[i].position = item.startMillis + 60000
         }
         if (!result.items[i].isAdult) {
            this._extendWatchingItem(result.items[i])
            filtered.push(result.items[i])
         }
      }
      this.continueWatching = filtered
      console.debug("continueWatching", this.continueWatching)
   })

   getCategory = flow(function* (category, fetchStrategy = CoCo.FetchStrategy.CacheFirst) {
      const result = yield CoCo.fetchDiscoverCategory(category, fetchStrategy)
      //console.debug("getCategory", result)
      return result
   })

   /*
   bookmarksAndEvents = flow(function* () {
      const events = []
      const bookmarks = yield rootStore.page.CoCoBookmarks.getBookmarksAsync(false)
      for (let i = 0; i < bookmarks.length; i++) {
         if (bookmarks[i].recordingId) {
            const ev = yield rootStore.page.MsEpg.getEventDetailsAsync(bookmarks[i].eventId)
            events.push({ bm: bookmarks[i], event: ev, type: "recording" })
            //console.debug("recording event=", ev)
         }
         else {
            const ev = yield rootStore.page.MsEpg.getEventDetailsAsync(bookmarks[i].eventId)
            events.push({ bm: bookmarks[i], event: ev, type: "event" })
            //console.debug("event=", ev)
         }
      }
      this.bmEvents = events
      console.debug("bookmarksAndEvents", events)
   })
   */
}

